import { Dictionary } from 'vue-router/types/router'

// 获取当前参数之外的其他参数
export const getOtherQuery = (query: Dictionary<string>): Dictionary<string> => {
  return Object.keys(query).reduce((acc, cur) => {
    if (cur !== 'redirect') {
      acc[cur] = query[cur]
    }
    return acc
  }, {} as Dictionary<string>)
}
